/**
 * useIndexData -- Index component data store with auto-refresh (Zustand).
 */
import { create } from 'zustand'
import { getIndexData } from '@/lib/api'
import type { IndexData } from '@/lib/types'

interface IndexDataState {
  data: IndexData | null
  prevData: IndexData | null
  loading: boolean
  error: string | null
  indexKey: string

  setIndexKey: (key: string) => void
  fetchIndex: (key?: string) => Promise<void>
}

export const useIndexData = create<IndexDataState>()((set, get) => ({
  data: null,
  prevData: null,
  loading: false,
  error: null,
  indexKey: 'ftse100',

  setIndexKey: (key) => {
    set({ indexKey: key, data: null, prevData: null })
    get().fetchIndex(key)
  },

  fetchIndex: async (key?: string) => {
    const indexKey = key ?? get().indexKey
    set({ loading: true, error: null })
    try {
      const data = await getIndexData(indexKey)
      set((state) => ({
        prevData: state.data,
        data,
        loading: false,
      }))
    } catch (e) {
      set({ error: String(e), loading: false })
    }
  },
}))
